import fenrirPic from "@/public/images/artists/fenrir.png";
import { Artist } from "@/types/types";

export const fenrir = {
  id: "210",
  name: "Fenrir",
  image: fenrirPic,
  description: `Fenrir's voice has a fierce, almost otherworldly quality, with powerful false chord screams that evoke a raw, demonic intensity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffenrir-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Growl", "Rock"],
      secondary: ["Experimental", "Scream"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 67,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
